import { type StateCreator } from 'zustand';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';

export type CommentRange = { endTime: number; startTime: number };

export type AnnotationDiscussionSlice = {
  activeDiscussion: ClipDiscussion | null;
  commentRange: CommentRange | null;
  isCommentRangeEnabled: boolean;
  resetAnnotationDiscussion: () => void;
  setActiveDiscussion: (discussion: ClipDiscussion | null) => void;
  setCommentRange: (range: CommentRange | null) => void;
  setCommentRangeEnabled: (enabled: boolean) => void;
};

export type AnnotationDiscussionSliceInitialState = Pick<
  AnnotationDiscussionSlice,
  'activeDiscussion' | 'commentRange' | 'isCommentRangeEnabled'
>;

export const INITIAL_ANNOTATION_DISCUSSION_STATE: AnnotationDiscussionSliceInitialState = {
  activeDiscussion: null,
  commentRange: null,
  isCommentRangeEnabled: false,
};

export type CreateAnnotationDiscussionSlice = (
  initialState?: Partial<AnnotationDiscussionSliceInitialState>,
) => StateCreator<AnnotationDiscussionSlice, [], [], AnnotationDiscussionSlice>;

export const createAnnotationDiscussionSlice: CreateAnnotationDiscussionSlice = (initialState) => (set) => {
  const mergedInitialState: AnnotationDiscussionSliceInitialState = {
    ...INITIAL_ANNOTATION_DISCUSSION_STATE,
    ...initialState,
  };

  return {
    ...mergedInitialState,
    resetAnnotationDiscussion: () => set({ ...mergedInitialState }),
    setActiveDiscussion: (activeDiscussion) => set({ activeDiscussion }),
    setCommentRange: (commentRange) => set({ commentRange }),
    setCommentRangeEnabled: (isCommentRangeEnabled) => set({ isCommentRangeEnabled }),
  };
};
